<div class="sku-panel" *ngIf="skus.length">
  <div class="sku-panal_container">
    <div class="sku-panel_title">{{ skus.length }} SKU's selected</div>
  </div>
  <div class="sku-panel_devider" *ngIf="!isPriceyard"></div>

  <div class="input-container" *ngIf="!isPriceyard">
    <div class="input-container_label">FBA Type:</div>
    <select
      class="input-container_input input-container_input--thin"
      (change)="updateFbaType()" 
      
      [formControl]="shipmentType"
    >
      <option *ngFor="let type of fbaTypes" [value]="type.id">{{type.name}}</option>
    </select>
  </div>
  <div class="sku-panel_devider"></div>

  <app-sku-settings
    [skus]="skus"
    *ngIf="userInfo.isPriceYard !== null"
  ></app-sku-settings>
</div>
